export default __webpack_public_path__ + "static/media/no_data.084649c5.svg";